import type { User } from '@/shared/types/User';

import { DEPLOYMENT_CUTOFF } from './constants';

export const isPreCutoffUser = (user: User): boolean => {
  if (!user?.created_date) return false;

  const created = new Date(user.created_date);

  if (Number.isNaN(created.valueOf())) return false;

  return created < DEPLOYMENT_CUTOFF;
};
